import CampaignService from "@/services/CampaignService.js";

export default {
  namespaced: true,
  state: {
    customerActiveCampaigns: [],
    openCampaigns: [],
    featuredCampaign: null,
    hasCampaignsJoined: false,
    ssoUrl: null,
    baseUrl: null,
    loading: false,
    errors: null
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_CAMPAIGN_DATA(state, data) {
      state.customerActiveCampaigns = data.customer_active_campaigns || [];
      state.openCampaigns = data.open_campaigns || [];
      state.featuredCampaign = data.featured_campaign || null;
      state.hasCampaignsJoined = data.has_campaigns_joined || false;
      state.ssoUrl = data.sso_url || null;
      state.baseUrl = data.url || null;
    }
  },
  getters: {
    hasActiveCampaigns(state) {
      return state.customerActiveCampaigns.length > 0;
    },
    hasOpenCampaigns(state) {
      return state.openCampaigns.length > 0;
    },
    customerActiveCampaigns(state) {
      return state.customerActiveCampaigns;
    },
    openCampaigns(state) {
      return state.openCampaigns;
    },
    featuredCampaign(state) {
      return state.featuredCampaign;
    },
    loading(state) {
      return state.loading;
    }
  },
  actions: {
    async getCampaignBanners({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        const response = await CampaignService.getCampaignBanners(request);
        const data = response.campaigns || response;
        commit("SET_CAMPAIGN_DATA", data);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    }
  }
};
